import { z } from 'zod';

import { BuilderAuthorizedContact, ThirdPartyAuthorizedContact } from '../loan/AuthorizedContact';

// SSN is omitted for security
export const AuthorizedContactApi = z.discriminatedUnion('type', [
  ThirdPartyAuthorizedContact.pick({
    email: true,
    address: true,
    phone: true,
    emailConsent: true,
    name: true,
    companyName: true,
    type: true,
    dateOfBirth: true,
  }).extend({
    id: z.string(),
  }),
  BuilderAuthorizedContact.pick({
    email: true,
    address: true,
    phone: true,
    emailConsent: true,
    type: true,
    companyName: true,
  }).extend({
    id: z.string(),
  }),
]);
export type AuthorizedContactApi = z.infer<typeof AuthorizedContactApi>;
